import React, {ReactNode, Children, isValidElement, cloneElement, FC} from "react";
import {Field} from "formik";
import {strings} from "../../../strings/strings";

interface BaseFormInputWrapperProps {
    name: string;
    validation?: {
        isRequired?: boolean;
        maxLength?: number;
        custom?: ((value: any) => string);
    };
    children: ReactNode;
}

export const FormItem: FC<BaseFormInputWrapperProps> = (props) => {
    const {name, validation,  children} = props;

    const validate = (value) => {
        if (validation?.isRequired && (value === null || value === undefined || value === '')) {
            return strings.validation.required;
        }
        if (validation?.maxLength && value?.length > validation.maxLength) {
            return strings.validation.maxLength.replace("{maxLength}", validation.maxLength.toString());
        }
        if (validation?.custom) {
            return validation.custom(value);
        }
    }

    return (
        <Field name={name} validate={validate}>
            {({field, form,  meta}) => (
                <>
                    {Children.map(
                        children,
                        (child) =>
                            isValidElement(child) &&
                            cloneElement(child, {
                                ...field,
                                error: Boolean((meta.touched && meta.error) || child.props.error),
                                validationError: meta.error || child.props.validationError,
                                onChange: (...params) => {
                                    form.setFieldValue(name, ...params);
                                    child.props.onChange?.(...params);
                                },
                            }),
                    )}
                </>
            )}
        </Field>
    )
}